import $ from 'jquery';
import DpPassengerRoomClass from './DpPassengerRoomClass';
import PassengerModalClass from '../hotel/PassengerModalClass';

export default class DpPassengerModalClass extends PassengerModalClass {
  constructor(_id, _parent) {
    super(_id, _parent);
    this.name = 'DpPassengerModalClass';
    this.roomMax = 6;
  }

  onSetData(_data) {
    super.onSetData(_data);
    this.checkBtnAddRoomVisibleChange();
  }

  onClickAddRoom(e) {
    if (this.roomCountChangeCheck({ adult: 1 })) {
      e.preventDefault();
      return;
    }
    super.onClickAddRoom(e);
  }

  addRoom() {
    let target = $(this.HTML_TEMPLATE_ROOM).appendTo(this.roomInsertTarget);
    const room = new DpPassengerRoomClass(target, this.rooms.length);
    room.onCreate();
    room.on(room.EVENT_DELETE, (e, p) => {
      this.isCloseBlock = true;
      this.removeRoom(p.index);
    });
    room.on(room.EVENT_ERROR, (e, p) => {
      this.onError(p.msg, p.target);
    });
    room.on(room.EVENT_CHANGE, (e, p) => {
      if (this.roomCountChangeCheck(p)) {
        this.onError(LtikeCommon.DP.TEXT.MODAL_PASSENGER_ERROR3, this.rooms[p.index].target);
      } else {
        this.rooms[p.index].addCount(p);
      }

      this.checkBtnAddRoomVisibleChange();
    });
    this.rooms.push(room);

    this.checkBtnAddRoomVisibleChange();
    // console.log(this.name,"addRoom",this.rooms.length);
  }

  checkBtnAddRoomVisibleChange() {
    this.btnAddRoomVisibleChange(!(this.rooms.length >= this.roomMax || this.roomCountChangeCheck({ adult: 1 })));
  }

  roomCountChangeCheck(_params) {
    let total = 0;
    for (let k in this.rooms) {
      total += this.rooms[k].adult.n;
      total += this.rooms[k].child.n;
    }

    if (_params.adult) { total += _params.adult; }
    if (_params.child) { total += _params.child; }

    return (total > 6);
  }

  onCheckSubmitError() {
    const re = super.onCheckSubmitError();

    if (!re.isError) {
      // console.log(this.name,"onCheckSubmitError",re);
      const res = DpPassengerModalClass.PassengersCheck(re.data);
      re.isError = res.isError;
      re.msg = res.msg;
    }
    return re;
  }

  /**
     * 宿泊者のエラーチェック
     * @param _data: Object
     * @returns {{msg: string, isError: boolean}}
     * @constructor
     */
  static PassengersCheck(_data) {
    // console.log(this.name,"PassengersCheck",_data);
    let isError = false;
    let msg = '';

    if (_data.length > 6) {
      msg = LtikeCommon.DP.TEXT.MODAL_PASSENGER_ERROR1;
      isError = true;
    } else {

      let total = { adult: 0, child: 0, ageList: [] };
      for (let k in _data) {
        const d = _data[k];

        total.adult += d.adult;
        total.child += d.child;
        total.ageList = total.ageList.concat(d.ageList);

        if (d.adult < 1) {
          isError = true;
          msg = LtikeCommon.DP.TEXT.MODAL_PASSENGER_ERROR2;
          break;
        } else if (d.adult + d.child > 6) {
          isError = true;
          msg = LtikeCommon.DP.TEXT.MODAL_PASSENGER_ERROR3;
          break;
        }
      }

      if (!isError) {
        let infant = 0;
        for (let k in total.ageList) { if (total.ageList[k] < 2) { infant += 1; } }
        if (infant > total.adult) {
          isError = true;
          msg = LtikeCommon.DP.TEXT.MODAL_PASSENGER_ERROR4;
        } else if (infant > 2) {
          isError = true;
          msg = LtikeCommon.DP.TEXT.MODAL_PASSENGER_ERROR5;
        }
      }
    }
    return { isError: isError, msg: msg };
  }
}
